import { State } from '../state';

export const eInvoicesReceived: State = {
    url: 'e-invoices/received'
};
